import clsx from 'clsx';
import React from 'react';
import styles from './Switch.module.scss';

type SwitchProps = React.ComponentProps<'input'> & {
    inlineLabel?: string;
    onCheckedChange?: (checked: boolean) => void;
};

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
    ({ inlineLabel, className, onCheckedChange, ...inputProps }, ref) => {
        return (
            <div className={clsx(styles.root, className)}>
                <div className={styles.switchContainer}>
                    {inlineLabel && <span className={styles.inlineLabel}>{inlineLabel}</span>}

                    <div
                        className={clsx(styles.switch, {
                            [styles.checked]: inputProps.checked,
                            [styles.disabled]: inputProps.disabled
                        })}
                    >
                        <span
                            className={clsx(styles.slide, {
                                [styles.slideChecked]: inputProps.checked
                            })}
                        ></span>
                        <input
                            ref={ref}
                            {...inputProps}
                            className={styles.input}
                            onChange={event => onCheckedChange?.(event.target.checked)}
                            type="checkbox"
                        />
                    </div>
                </div>
            </div>
        );
    }
);

Switch.displayName = 'Switch';
